import React, { Component } from 'react';

//IMPORT REDUX
import { connect } from 'react-redux';
import { addModalExport } from '../../redux/actions/ConfigFileAction'
import {addReset} from '../../redux/actions/AppAction'
import Exit from '../../assets/svg/Exit.svg';

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
    Grid,
    Segment,
    Button,
    Icon,
    Modal,
    Header,
    Image,
    Form,
    Label,
    Item,
    Container
} from 'semantic-ui-react';

import API from '../../services/api';

import { translate } from "react-translate";

const mapStateToProps = state => ({
    app: state.app,
    configfile: state.configfile
})

const mapActionToProps = {
    addModalExport: addModalExport,
    addReset: addReset
}


class ConnectedResetComponent extends Component {
   
    constructor(props){
        super(props)

        this.state = {
            email: null,
            error_input_email: null,
            response: null
        }

        this.handleChangeEmail = this.handleChangeEmail.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.closeModalExport = this.closeModalExport.bind(this)
        
    }


    closeModalExport(){
        this.props.addReset(false)
    }

    handleChangeEmail(e){
        
        if(e.target.value === "" || e.target.value === null || e.target.value === undefined ){
            this.setState({
                email: e.target.value,
                error_input_email: true  
            })
        }else{
            this.setState({
                email: e.target.value,
                error_input_email: false  
            })
        }

    }

    handleSubmit(e){
        e.preventDefault();
        var self = this;
        if(this.state.email === "" || this.state.email === null || this.state.email === undefined){
            this.setState({
                email: e.target.value,
                error_input_email: true  
            })
        }else{

            if(!this.state.error_input_email){

                var resetData = {
                    email : this.state.email,
                    lang: this.props.app.lang
                }
                API.resetPassword(resetData).then((res) => {
                    self.setState({
                        response: res.data
                    })
                });

            }else{
                this.setState({
                    email: e.target.value,
                    error_input_email: true  
                })
            }
        }


    }

    render() {


        const { t } = this.props;
        return (

            <Modal style={{ width: '390px' }} observeChanges='true' size='mini' open={this.props.app.reset} >
                <Modal.Content >
                    <Grid
                        textAlign='center'
                        style={{ height: '100%' }}
                        verticalAlign='middle'>
                        <Grid.Column style={{ maxWidth: 450 }}>
                                <Image onClick={this.closeModalExport} src={Exit} centered floated='right' style={{paddingTop: "6px", paddingBottom: "7px"}} />
                                <Header as='h3' style={{ color: '#0964c1', margin: '0em 0 1em 1em', paddingLeft: '15px', fontSize: '1.5em' }} textAlign='center'>
                                    {t('title')}
                                </Header>
                            
                            <Form onSubmit={this.handleSubmit}>
                                <Item.Header as='h5' style={{ color: '#707070' }}>{t('give_mail')}</Item.Header>

                                    {
                                        this.state.error_input_email ? (
                                            <input
                                                type='email'
                                                onChange={this.handleChangeEmail}
                                                placeholder={t("placeholder")}
                                                style={{ marginBottom: '17px', backgroundColor: '#f7f7f9', color: '#707070', borderColor: '#db2828'}} />

                                        ):(
                                            <input
                                                type='email'
                                                onChange={this.handleChangeEmail}
                                                placeholder={t("placeholder")}
                                                style={{ marginBottom: '17px', backgroundColor: '#f7f7f9', color: '#707070' }} />

                                        )
                                    }

                                    {
                                        this.state.response ? (

                                            <Grid.Column verticalAlign={"middle"} style={{paddingBottom: '15px'}} >
                                                <Segment inverted color='green' tertiary>
                                                    <Icon name={"checkmark"} />{t("success")}
                                                </Segment>
                                            </Grid.Column>
                                        ):(
                                            <div></div>
                                        )
                                    }
                                    <Button type='submit' fluid style={{ height: '45px', fontSize: '16px', border: '1px solid #d4c37e' }} color='yellow'>{t("send")}</Button>
                            </Form>
                        </Grid.Column>
                    </Grid>
                </Modal.Content>
            </Modal>
        )
    }
}

const ResetComponent = connect(mapStateToProps, mapActionToProps)(ConnectedResetComponent);
export default translate("ResetComponent")(ResetComponent);








// WEBPACK FOOTER //
// ./src/components/Login/ResetComponent.js